import { create } from 'zustand';
import { resolveTimezone } from '../utils/timezoneUtils';

export const useTimezoneStore = create((set, get) => ({
  selectedTimezone: null,
  deviceTimezone: null,
  startTimezone: null,

  setSelectedTimezone: selectedTimezone => {
    set({ selectedTimezone: selectedTimezone || null });
  },
  setDeviceTimezone: timezone => set({ deviceTimezone: timezone || null }),
  setStartTimezone: timezone => set({ startTimezone: timezone || null }),
  getActiveTimezone: () => resolveTimezone(get()),
  resetDeviceTimezones: () => set({ deviceTimezone: null, startTimezone: null }),
}));
